import { Typography } from "keep-react";
import React from "react";

const NAME = "Shasam expertos en alcoholismo";
const parrafo1 ="El alcohol es la sustancia legal psicoactiva más consumida en Chile y en la gran mayoría de países. Su consumo se relaciona con más de 60 enfermedades.";
const parrafo2 ="El alcoholismo se manifiesta por la presencia de conductas que demuestran la necesidad y pérdida de libertad frente al alcohol, con dificultad para controlar su consumo. También por la existencia de tolerancia y síndrome de abstinencia. En resumidas cuentas, pierdes el control sobre ti mismo y no tienes la capacidad de dejar de beber alcohol, aunque no paras de proponértelo. Por suerte, existen soluciones."
const NAME1 ="El alcoholismo, un riesgo para la salud";
const parrafo3 ="El consumo de alcohol moderado no es un problema de salud crítico, el riesgo se produce al cruzar la delgada línea entre un consumo social y un consumo severo que cause dependencia (adicción), los alcohólicos consumen en exceso, frecuentemente y de forma prolongada el alcohol.";
const NAME2 = "El alcohol, un problema de salud"
const parrafo4 ="El alcoholismo es una enfermedad crónica donde el alcohólico no controla el impulso de ingesta de bebidas alcohólicas, afectando su salud física, mental, economía, relaciones familiares e interacción social. Por estas razones es vital que el paciente se centre y ponga empeño en dejar el alcohol con ayuda profesional, como la que brindamos en Shasam a través de nuestra terapia alcoholismo online.";
const parrafo5 ="El trastorno por consumo adictivo de alcohol produce: Ansiedad, irritabilidad, pérdida de control, cambios bruscos emocionales…";
const parrafo6 ="Las causas por las cuales una persona tiende a consumir alcohol son diversas, algunas de ellas incluyen: Aceptación social, por diversión, para vencer la timidez, efectos de bienestar, escape emocional de los problemas, étc.";
const parrafo7 ="Para aprender las estrategias sobre cómo dejar de beber, es importante que el paciente acepte que padece un problema de alcoholismo.";
const parrafo8 ="Existen factores de riesgos que contribuyen al desarrollo de la adicción al alcohol, entre los cuales se encuentran: Antecedentes familiares, inicio de consumo de alcohol a temprana edad, factores psicológicos (baja autoestima, depresión, ansiedad) y factores sociales (conflictos de pareja, desempleo, presión social).";
const parrafo9 ="Al año, se producen más de tres millones de muertes a nivel mundial producto de la ingesta de alcohol, cifras aportadas por la OMS, siendo éste un motivo de peso para que las personas alcohólicas busquen ayuda para dejar de beber alcohol.";
const parrafo10 ="Las consecuencias nocivas para la salud que produce el alcohol en las personas que tienen problemas con el alcohol se pueden clasificar en:";
const titulo1 ="1.- Físicas";
const parrafo12 ="Cáncer, cirrosis, enfermedades del hígado, hipertensión, diabetes, insomnio, gastritis, problemas cardiovasculares, pancreatitis, déficit nutricional, apoplejía, degeneración cerebral, envejecimiento prematuro, coma, muerte, epilepsia, disfunción eréctil, étc.";
const titulo2 ="2.- Psicológicas";
const parrafo13 ="Ansiedad, depresión, celopatía, demencia, psicosis, agresividad, ira, falta de concentración, pérdida de la memoria, étc.";
const titulo3 ="3.- Sociales";
const parrafo14 ="Problemas de interacción social, problemas familiares, maltrato, agresiones sexuales, suicidio, étc.";



const parrafo15 ="El tratamiento del alcoholismo es un trabajo en equipo, donde intervienen especialistas y familiares y entorno cercano del paciente. El consumo de alcohol de forma incontrolada, puede estar determinado por la personalidad de la persona, el ambiente socio-cultural, accesibilidad y permisividad al consumo de bebidas alcohólicas.";
const parrafo16 ="Las personas con esta adicción, tienen un impacto negativo en el entorno en el que se desenvuelven, pueden producir daños a terceros debido a accidentes de tráfico, conductas violentas con familiares, amigos, compañeros de trabajo e incluso desconocidos, etc.";
const parrafo17 ="Las razones para dejar de beber son muchas, principalmente porque el alcohol es tóxico y causa daños irreparables al organismo cuando su consumo es crónico, otras razones por las cuales se debe dejar de consumir alcohol porque es una sustancia adictiva y neurotóxico, que puede provocar cáncer, problemas emocionales, conflictos inter-personales y en el trabajo o apatía severa. Al mismo tiempo, es la sustancia que da entrada a otras adicciones.";
const parrafo18 ="Los problemas de alcohol pueden superarse, siempre que el alcohólico acepte que está enfermo y permita la intervención del equipo multidisciplinar para ayudarlo a superar la adicción al consumo de alcohol. Los beneficios de dejar de beber alcohol incluyen:";
const li_1 ="– Favorece el estado de ánimo";
const li_2 ="– Disminuye el daño al estómago, páncreas e hígado";
const li_3 ="– Mejora y fortalece el sistema inmunológico";
const li_4 ="– Mejora el aspecto de la piel";
const li_5 ="– Estimula la memoria y la concentración";
const parrafo19 ="Todos estos beneficios generan un cambio ultra positivo y global en el paciente, recupera la felicidad y ganas de vivir, se relaciona con los demás de forma mucho más positiva y natural, se vuelve mucho más capacitado para el empleo, deja atrás deudas y problemas derivados de las adicciones.";



export const Alcohol = () => {

    return (
      <div>
       
       <div className="flex justify-center mx-32 items-center mt-8">
        <div className="flex-1">
          <Typography className="text-sky-400 text-5xl font-medium">
            {NAME}
          </Typography>
          <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo1}</Typography>
            </Typography>
 
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo2}</Typography>
            </Typography>

            <Typography className="text-sky-400 text-5xl font-medium">
            {NAME1}
          </Typography>
          <br></br>
          <Typography className="text-sky-400 text-5xl font-small">
            {NAME2}
          </Typography>
          <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo3}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo4}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo5}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo6}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo7}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo8}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo9}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo10}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{titulo1}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo12}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{titulo2}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo13}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{titulo3}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo14}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo15}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo16}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo17}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo18}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{li_1}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{li_2}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{li_3}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{li_4}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{li_5}</Typography>
            </Typography>
            <Typography className="text-justify space-y-4 text-xl m-5">
            <Typography>{parrafo19}</Typography>
            </Typography>
  </div>
    </div>
      </div>
    );
  }

  